<script setup>
import { computed, inject } from 'vue'
import { RouterLink } from 'vue-router'
import { useI18n } from 'vue-i18n'
import Avatar from './Avatar.vue'
import Icon from './Icon.vue'
import PanelSearch from './PanelSearch.vue'

const props = defineProps({
  sidebarMini: { type: Boolean, default: false },
  sidebarClosed: { type: Boolean, default: false },
  user: { type: Object, default: () => undefined }
})

defineEmits(['toggleSidebar'])

const { t } = useI18n()
const config = inject('config')
const mobileLabel = computed(() => t('common.' + (props.sidebarClosed ? 'Expand' : 'Collapse')))
const desktopLabel = computed(() => t('common.' + (props.sidebarMini ? 'Expand' : 'Collapse')))
const name = config.branding.name

</script>

<template>
  <header :class="['topbar', { 'signed-in': props.user }]">
    <div class="brand">
      <button class="sidebar-toggle desktop-toggle" type="button" :title="desktopLabel" :aria-label="desktopLabel" :aria-expanded="!sidebarMini" @click="$emit('toggleSidebar')">
        <icon :name="sidebarMini ? 'chevron-right' : 'chevron-left'" />
      </button>
      <button class="sidebar-toggle mobile-toggle" type="button" :title="mobileLabel" :aria-label="mobileLabel" :aria-expanded="!sidebarClosed" @click="$emit('toggleSidebar')">
        <icon name="nav-menu" />
      </button>
      <div :data-name="name" class="name">{{ name }}</div>
    </div>
    <panel-search v-if="props.user" />
    <router-link v-if="props.user" v-hotkey="'g a'" class="account-link" :to="{ name: 'Self' }" :title="props.user.username">
      <span class="username">{{ props.user.username }}</span>
      <avatar :user="props.user" />
    </router-link>
  </header>
</template>
